import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { styled } from 'styled-components';
import { S as ns } from '../SignUP/NewSingUp.style';
import { S } from '../SignUP/SignUpForm.style';
import LoginSerivce from '../../service/login/login';
import PageTop, { MainPageTop } from '../components/pageTop/PageTop';
import Menu from '../components/menu/Menu';
import Footer from '../components/footer/Footer';
const LoginEmail = () => {
  const [id, setId] = useState('');
  const [password, setPassword] = useState('');
  const [idSave, setIdSave] = useState(false);
  const navigate = useNavigate();
  const { setIsLoggedIn } = useAuth();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [isIdValid, setIsIdValid] = useState(true);
  const [loginError, setLoginError] = useState(
    '아이디 혹은 비밀번호가 일치하지 않습니다.',
  );
  const [openMenu, setOpenMenu] = useState(false);

  const LoginApi = async () => {
    try {
      const result = await LoginSerivce.login({
        userid: id,
        password: password,
      });
      if (result.status === 'success') {
        localStorage.setItem('accessToken', result.data.accessToken);
        localStorage.setItem('userType', result.data.user.usertype);
        localStorage.setItem('userName', result.data.user.name);
        localStorage.setItem('plan_end', result.data.user.plan_end);
        localStorage.setItem(
          'recommend_code',
          result.data.user.recommend_code ?? '', // null이면 빈 문자열로 저장
        );
        setIsLoggedIn(true);

        navigate('/', { replace: true, state: { index: 0 } });
      }
    } catch (error: any) {
      setIsIdValid(false);
      setLoginError(
        error.response.data.message.includes('인증')
          ? error.response.data.message
          : '아이디 혹은 비밀번호가 일치하지 않습니다.',
      );
      error.response.data.message.includes('인증') &&
        alert(`${error.response.data.message}\n인증 후 연락드리겠습니다.`);
      console.log(error);
    }
  };

  const SocialLoginApi = (type: string) => {
    LoginSerivce.socialLogin(type, window.location.origin);
  };

  // 페이지가 처음 로드될 때 로컬 스토리지에서 id 값을 가져옵니다.
  useEffect(() => {
    const storedId = localStorage.getItem('id');
    if (storedId) {
      setId(storedId); // 로컬스토리지에 값이 있다면 id 상태로 설정
    }
  }, []); // 빈 배열을 주면 컴포넌트 마운트 시에만 실행됩니다.

  useEffect(() => {
    if (idSave) {
      localStorage.setItem('id', id);
    } else {
      localStorage.removeItem('id');
    }
  }, [idSave]);

  return (
    <Container>
      <div
        style={{
          padding: '16px',
        }}
      >
        <img
          onClick={() => {
            navigate(-1);
          }}
          src="/assets/images/arrow/back-arrow-left-gray.svg"
        ></img>
      </div>
      <ScrollContainer>
        <Inner>
          <Content>
            <Section1>
              <form
                style={{ width: '100%' }}
                onSubmit={(e) => {
                  e.preventDefault();
                  LoginApi();
                }}
              >
                <InputWrapper>
                  <Section1Content1>
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 24,
                      }}
                    >
                      <InputBox>
                        <span>이메일</span>
                        <LoginInput
                          isValid={true}
                          value={id}
                          placeholder="이메일을 입력해주세요."
                          onChange={(e: any) => {
                            setId(e.target.value);
                          }}
                        />
                      </InputBox>
                      <InputBox>
                        <span>비밀번호</span>
                        <div>
                          <LoginInput
                            isValid={true}
                            placeholder="비밀번호를 입력해주세요."
                            onChange={(e: any) => {
                              setPassword(e.target.value);
                            }}
                            // secureTextEntry={true}
                            security="true"
                            type={passwordVisible ? 'text' : 'password'}
                          />
                          {!isIdValid && (
                            <S.InputInfoBox isValid={isIdValid}>
                              <img
                                src={`/assets/images/icon/${'signUpInfo_icon_NotValid'}.svg`}
                                alt=""
                              />
                              <div
                                style={{
                                  position: 'relative',
                                  // marginBottom:
                                  //   password.length === 0 ? '20px' : undefined,
                                }}
                              >
                                <div>{loginError}</div>
                              </div>
                            </S.InputInfoBox>
                          )}
                        </div>
                        <S.VisibleButton
                          style={{
                            top: '50px',
                          }}
                        >
                          <img
                            onClick={() => {
                              setPasswordVisible((prev) => !prev);
                            }}
                            src={`/assets/images/icon/${passwordVisible ? 'Visible_icon' : 'notVisible_icon'}.svg`}
                            alt=""
                          />
                        </S.VisibleButton>
                      </InputBox>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row' as 'row',
                          gap: 8,
                          width: '100%',
                          justifyContent: 'flex-start',
                          fontSize: '13px',
                          fontWeight: '500',
                        }}
                      >
                        <img
                          //   style={{
                          //     width: '20px',
                          //     height: '20px',
                          //   }}
                          onClick={() => {
                            setIdSave((prev) => !prev);
                          }}
                          src={
                            idSave
                              ? '/assets/images/check/idSaveOn.svg'
                              : '/assets/images/check/idSaveOff.svg'
                          }
                          alt=""
                        />
                        <span>아이디 저장</span>
                      </div>
                    </div>
                  </Section1Content1>
                  <LoginWrapper>
                    <LoginBtn
                      type="submit"
                      onClick={() => {
                        LoginApi();
                      }}
                    >
                      로그인
                    </LoginBtn>
                    <UserContent>
                      <FindBox>
                        <FindBox>
                          <div
                            onClick={() => {
                              navigate('/find', { state: { type: 'id' } });
                            }}
                          >
                            아이디&nbsp;
                          </div>
                          <div> ∙&nbsp;</div>
                          <div
                            onClick={() => {
                              navigate('/find', {
                                state: { type: 'password' },
                              });
                            }}
                          >
                            비밀번호 찾기
                          </div>
                        </FindBox>
                      </FindBox>
                      <div
                        onClick={() => {
                          navigate('/signUp');
                        }}
                      >
                        회원가입
                      </div>
                    </UserContent>
                  </LoginWrapper>
                </InputWrapper>
              </form>
            </Section1>
          </Content>
        </Inner>
      </ScrollContainer>
    </Container>
  );
};

export default LoginEmail;

const FindBox = styled.div`
  display: flex;
  flex-direction: row;
  // width: 100%;
`;
interface InputBoxProps {
  isValid?: boolean;
  isavailable?: boolean;
}
const LoginInput = styled.input<InputBoxProps>`
  border-radius: 8px;
  padding-inline: 16px;
  padding-block: 12px;
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 500;
  line-height: 23.2px;
  text-align: left;
  width: 100%;
  background-color: #f5f7fa;
  border: none;
  ::placeholder {
    color: #171e2666;
  }
  &:focus {
    outline: none; /* 기본 브라우저 스타일 제거 */
    border: 1px solid ${(props) => (props.isValid ? '#008AFF' : 'red')};
  }
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  width: 100%;
`;

const Container = styled.div`
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  overflow: hidden;
  position: relative;
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
  padding: 40px 16px;
  gap: 40px;
`;
const ScrollContainer = styled.div`
  flex-grow: 1;
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
  gap: 40px;
  width: 100%;
`;
const UserContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: #616161;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 20.3px;
  cursor: pointer;
`;

const InputBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: relative;
`;
const Section1 = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
  justify-content: center;
  align-items: center;
`;
const Text1 = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 18px;
  font-weight: 700;
  line-height: 26px;
  color: #171e26;
  text-align: center;
`;

const Section1Content1 = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

const LoginWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: flex-end;
  width: 100%;
`;
const LoginBtn = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #008aff;
  border-radius: 8px;
  width: 100%;
  padding-block: 14px;
  padding-inline: 16px;
  cursor: pointer;
  border: none;
  color: #ffffff;
`;
